import axios from "axios";
import * as mem from "./recopieLotFournisseur";
import {DEBUG} from "./utilitaires";



// relation fournisseur/lot
export async function goSetRappelLot(
  idL,
  rappel
) {
  const formData = new FormData();

  formData.append("idL", idL);
  formData.append("rappel", rappel);
  
  try {
    // const res = await axios.post("http://localhost:3400/fournisseurlot", formData);
    const res = await axios.post("https://" + mem.addressIPRemotebd + ":3400/rappellot", formData); //REMETTRE HTTPS
    console.log(res.data.message);
    console.log(res.data);
  } catch (e) {
    console.log(e);
    console.log("erreur dans l'acces setRappelLot à la base de données ");
    // throw(e)
  }
}


// relation fournisseur/lot
export async function goCreerFournisseurLot(
  idF,
  idL
) {
  const formData = new FormData();

  formData.append("idF", idF);
  formData.append("idL", idL);
  
  try {
    // const res = await axios.post("http://localhost:3400/fournisseurlot", formData);
    const res = await axios.post("https://" + mem.addressIPRemotebd + ":3400/fournisseurlot", formData);
    console.log(res.data.message);
    console.log(res.data);
  } catch (e) {
    console.log(e);
    console.log("erreur dans l'acces FournisseurLot à la base de données ");
    // throw(e)
  }
}

// relation lotpere/lotfils
export async function goCreerLotPereLotFils(
  idPere,
  idFils,
  pourcent,
  carboneRaj
) {
  const formData = new FormData();

  formData.append("idLotPere", idPere);
  formData.append("idLotFils", idFils);
  formData.append("pourcent", pourcent);
  formData.append("carboneRaj", carboneRaj);

  try {
    // const res = await axios.post("http://localhost:3400/lotperefils", formData);
    const res = await axios.post("https://" + mem.addressIPRemotebd +":3400/lotperefils", formData);
    console.log(res.data.message);
    console.log(res.data);
  } catch (e) {
    console.log(e);
    console.log("erreur dans l'acces LotPereFils à la base de données ");
    // throw(e)
  }
}

// table fournisseur
export async function goCreerFournisseurBD(
  idF,
  nomF,
  identF,
  addrP,
  pays,
  compteF,
  nomC,
  addrE,
  numT
) {
  const formData = new FormData();
  
  if (DEBUG) {
	  console.log("dans goCreerFournisseur: ");
	  console.log("idFournisseur: ", idF);
	  console.log("nomFournisseur: ", nomF);
	  console.log("identFournisseur: ", identF);
	  console.log("addrPostale: ", addrP);
	  console.log("pays: ", pays);
	  console.log("compteFournisseur: ", compteF);
	  console.log("nomContact: ", nomC);
	  console.log("addrEmail: ", addrE);
	  console.log("numTelephone: ", numT);
  }

  formData.append("idFournisseur", idF);
  formData.append("nomFournisseur", nomF);
  formData.append("identFournisseur", identF);
  formData.append("addrPostale", addrP);
  formData.append("pays", pays);
  formData.append("compteFournisseur", compteF);
  formData.append("nomContact", nomC);
  formData.append("addrEmail", addrE);
  formData.append("numTelephone", numT);

  try {
    // const res = await axios.post("http://localhost:3400/fournisseur", formData);
    const res = await axios.post("https://" + mem.addressIPRemotebd + ":3400/fournisseur", formData);
    console.log(res.data.message);
    console.log(res.data);
  } catch (e) {
    console.log(e);
    console.log("erreur dans l'acces Fournisseur à la base de données ");
    // throw(e)
  }
}

//table Lot
export async function goCreerLotBD(
  idL,
  typeL,
  nomL,
  libel,
  hashIm,
  descrL,
  argL,
  nbreArt,
  idF,
  note,
  classement,
  nomFabr,
  categorie,
  pourcentExt,
  paysFabr,
  carbone,
  carboneTot,
  carbonePert,
  DLC
) {
  const formData = new FormData();

  formData.append("idLot", idL);
  formData.append("typeLot", typeL);
  formData.append("nomLot", nomL);
  formData.append("libelleLot", libel);
  formData.append("hashImage", hashIm);
  formData.append("descrLot", descrL);
  formData.append("argLot", argL);
  formData.append("nbreArticles", nbreArt);
  formData.append("idFournisseur", idF);
  formData.append("note", note);
  formData.append("classement", classement);
  formData.append("nomFabr", nomFabr);
  formData.append("categorie", categorie);
  formData.append("pourcentExt", pourcentExt);
  formData.append("paysFabr", paysFabr);
  formData.append("carbone", carbone);
  formData.append("carboneTot", carboneTot);
  formData.append("carbonePert", carbonePert);
  formData.append("DLC", DLC);
  
  
  
  try {
    // const res = await axios.post("http://localhost:3400/Lot", formData);
    const res = await axios.post("https://" + mem.addressIPRemotebd + ":3400/Lot", formData);
    console.log(res.data.message);
    console.log(res.data);
  } catch (e) {
    console.log(e);
    console.log("erreur dans l'acces Lot à la base de données ");
    // throw(e)
  }
}


